var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#FEF3C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9986 15.25C24.5532 15.25 25.065 15.543 25.3462 16.0234L33.7837 30.3984C34.0689 30.8828 34.0689 31.4805 33.7915 31.9648C33.5142 32.4492 32.9947 32.75 32.4361 32.75H15.5611C15.0025 32.75 14.4829 32.4492 14.2056 31.9648C13.9282 31.4805 13.9322 30.8789 14.2134 30.3984L22.6509 16.0234C22.9322 15.543 23.4439 15.25 23.9986 15.25ZM23.9986 20.25C23.479 20.25 23.0611 20.668 23.0611 21.1875V25.5625C23.0611 26.082 23.479 26.5 23.9986 26.5Cnan nan 24.9361 26.082 24.9361 25.5625V21.1875C24.9361 20.668 24.5181 20.25 23.9986 20.25ZM25.2486 29C25.2486 28.3101 24.6885 27.75 23.9986 27.75C23.3087 27.75 22.7486 28.3101 22.7486 29C22.7486 29.6899 23.3087 30.25 23.9986 30.25C24.6885 30.25 25.2486 29.6899 25.2486 29Z",
    fill: "#D97706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.f286fe7fcc990428a9e83d99244d6377.svg";
export { ForwardRef as ReactComponent };